export const environment = {
  production: false,
  apiBaseUri: 'https://backend-inscription.preprod-orange.insitaction.org',
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts